import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ATS_Fullstack, Button, ComponentSync, LL_H_C, LL_H_T, LL_V_L, ModuleFE_Toaster, TS_Input, TS_PropRenderer, TS_Table } from '@nu-art/thunderstorm-frontend/index';
import { __stringify, DateTimeFormat_yyyyMMDDTHHmmss, groupArrayBy, removeFromArrayByIndex, } from '@nu-art/ts-common';
import { TS_Icons } from '@nu-art/ts-styles';
import { ModuleFE_PushPubSub } from '../../modules/ModuleFE_PushPubSub.js';
import './ATS_PushPubSub.scss';
import { TS_InputV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_Input/index';
import { ModuleFE_PushSubscription } from '../../modules/ModuleFE_PushSubscription.js';
function createNewInstance(key = '', value = '') {
    return { key, value };
}
const ConfigPreset_1 = {
    label: 'Matching simple',
    config: {
        registerKey: 'test-key',
        registerFilter: [createNewInstance('prop-key', 'value1')],
        triggerKey: 'test-key',
        triggerFilter: [createNewInstance('prop-key', 'value1')],
    }
};
export class ATS_PushPubSub extends ComponentSync {
    // ######################## Static ########################
    static screen = {
        name: `Push Messages`,
        renderer: this,
        group: ATS_Fullstack,
        modulesToAwait: [ModuleFE_PushSubscription]
    };
    // ######################## Lifecycle ########################
    __onSubscriptionUpdated(...params) {
        this.forceUpdate();
    }
    __onMessageReceived(payload) {
        console.log('GOT PUSH:', payload.message.topic, payload.message.props, payload.message.data);
        this.setState({ receivedPushPayloads: [...this.state.receivedPushPayloads, payload] });
    }
    deriveStateFromProps(nextProps, _state) {
        const state = _state ?? {};
        return { ...state, ...ConfigPreset_1.config, receivedPushPayloads: [] };
    }
    // ######################## Logic ########################
    composeFilter(objProps) {
        return objProps.reduce((toRet, item) => {
            if (!!item.key && item.key !== '')
                toRet[item.key] = item.value;
            return toRet;
        }, {});
    }
    trigger = async () => {
        if (!ModuleFE_PushPubSub.hasToken())
            return ModuleFE_Toaster.toastError('No push token generated');
        const filter = this.composeFilter(this.state.triggerFilter);
        const data = { 'a': 'aaa' };
        const message = { topic: this.state.triggerKey, filter, data };
        this.logInfo(`triggering push: ${__stringify(message, true)}`);
        await ModuleFE_PushPubSub.v1.test({ message }).executeSync();
    };
    subscribe = async () => {
        if (!ModuleFE_PushPubSub.hasToken())
            return ModuleFE_Toaster.toastError('No push token generated');
        await ModuleFE_PushPubSub.v1.register({
            topic: this.state.registerKey,
            filter: this.composeFilter(this.state.registerFilter)
        }).executeSync();
    };
    // ######################## Render ########################
    render() {
        const className = _className('notification-icon', ModuleFE_PushPubSub.isNotificationEnabled() ? 'notification-enabled' : 'notification-disabled');
        const mySubscription = ModuleFE_PushSubscription.cache.all()
            .filter(subscription => subscription.pushSessionId === ModuleFE_PushPubSub.getPushSessionId());
        return _jsxs(LL_V_L, { className: "ats-PushPubSub", children: [_jsxs(LL_H_C, { children: ["Push Session Id: ", ModuleFE_PushPubSub.getPushSessionId()] }), _jsxs(LL_H_C, { className: "header match_width", children: [_jsx("div", { children: TS_Icons.bell.component({
                                className: className,
                                onClick: async (e) => {
                                    await ModuleFE_PushPubSub.requestPermissions();
                                }
                            }) }), _jsx(Button, { onClick: ModuleFE_PushPubSub.deleteToken, children: "Delete Token" }), _jsx(Button, { onClick: async () => await ModuleFE_PushPubSub.getToken(), children: "Generate Token" })] }), _jsxs(LL_H_T, { className: "panels-container h-gap__n match_width", children: [this.renderPanel('Register', this.state.registerFilter, 'registerKey', this.subscribe), this.renderPanel('Trigger', this.state.triggerFilter, 'triggerKey', this.trigger)] }), _jsxs(LL_H_T, { className: "panels-container h-gap__n match_width", children: [_jsx(LL_V_L, { className: "panel v-gap__l", children: groupArrayBy(mySubscription, (subscription) => subscription.topic)
                                .map((subscription, index) => _jsxs(LL_H_C, { children: [_jsx(LL_H_C, { style: { width: 100 }, children: subscription.key }), _jsx(LL_V_L, { children: subscription.values.map((value, index) => _jsxs(LL_H_C, { children: [_jsx(TS_Icons.bin.component, { onClick: () => ModuleFE_PushSubscription.v1.delete({ _id: value._id }).executeSync() }), JSON.stringify(value.filter)] }, index)) })] }, index)) }), _jsx(LL_V_L, { className: "panel", children: this.state.receivedPushPayloads.map(payload => _jsxs(LL_H_C, { children: [_jsx("span", { style: { width: 200 }, children: DateTimeFormat_yyyyMMDDTHHmmss.format(payload.timestamp) }), JSON.stringify(payload.message)] })) })] })] });
    }
    renderPanel(title, rows, key, action) {
        const cellRenderer = (prop, item, index) => {
            if (prop === 'delete')
                return _jsx(TS_Icons.bin.component, { onClick: () => {
                        removeFromArrayByIndex(rows, index);
                        this.forceUpdate();
                    }, children: "Delete Row" });
            return _jsx(TS_Input, { onChange: (value) => {
                    item[prop] = value;
                    this.forceUpdate();
                }, className: 'match_width', type: "text", placeholder: `Enter ${prop}`, id: `${key}-${prop}-${index}`, value: item[prop].toString() });
        };
        const addNewRow = () => {
            rows[rows.length] = createNewInstance();
            this.forceUpdate();
        };
        return _jsxs(LL_V_L, { className: "panel", children: [_jsxs(LL_H_C, { className: "panel-header match_width flex__justify-center", children: [title, _jsx(Button, { variant: 'secondary', onClick: addNewRow, children: "Add" }), _jsx(Button, { variant: 'primary', onClick: action, children: "Send" })] }), _jsxs(LL_V_L, { className: "panel-content v-gap__n", children: [_jsx(TS_PropRenderer.Vertical, { label: 'Key', children: _jsx(TS_InputV2, { onChange: (value) => this.setState({ [key]: value }), type: "text", id: key, value: this.state[key] }) }), _jsx(TS_Table, { id: key, table: { className: 'match_width' }, header: ['key', 'value', { header: 'delete', widthPx: 30 }], rows: rows, headerRenderer: columnKey => _jsx("div", { children: columnKey === 'delete' ? '' : columnKey }), cellRenderer: cellRenderer, tr: { style: { padding: '5px' } } })] })] });
    }
    title(title) {
        return _jsx("div", { children: title });
    }
}
//# sourceMappingURL=ATS_PushPubSub.js.map